var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalentUnselectedArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Talent_Unselected_Arrow_Right_svg__filter0_d_316_22171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.646 6.646L2.854.854A.5.5 0 002 1.207v11.586a.5.5 0 00.854.353l5.792-5.792a.5.5 0 000-.708z",
    fill: "#25254B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.677 1.03L8.47 6.823a.25.25 0 010 .354L2.677 12.97a.25.25 0 01-.427-.177V1.207a.25.25 0 01.427-.177z",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Talent_Unselected_Arrow_Right_svg__filter0_d_316_22171",
    x: 0,
    y: 0.706,
    width: 10.793,
    height: 16.588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_22171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_316_22171",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/svg/talenttree/Talent_Unselected_Arrow_Right.svg";
export { SvgTalentUnselectedArrowRight as ReactComponent };